(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "66f2cdfedb80af09940aeab6";
              window.beaePageSetting.pageTitle = "Ingredients"; 
              window.beaePageSetting.pageType = "section";

          let js_9BGI7B8M = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-pvvb9nhssection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-pvvb9nhs',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-pvvb9nhs');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var n,l;let s=a.target;if(!s.classList.contains("beae-grid-carousel"))return;let r=Math.round((s.scrollLeft+s.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(s.offsetWidth*.8))+1;(n=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||n.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+r+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),s=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),r=[];if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(window.innerWidth>=768){if(a){const n=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);n&&(a.innerHTML=n.html,r.push("desktop"))}}else if(s){const n=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,s);n&&(s.innerHTML=n.html,r.push("mobile"))}}(a||s)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!r.includes("desktop")&&window.innerWidth>=768&&a){const n=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);n&&(a.innerHTML=n.html,r.push("desktop"))}if(!r.includes("mobile")&&window.innerWidth<768&&s){const n=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,s);n&&(s.innerHTML=n.html,r.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((r,n)=>{r.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),n.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-pvvb9nhs: ', ex)
      };
    

      try {
        let argid = 'beae-pvvb9nhssection-featured-collection',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-pvvb9nhs',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-pvvb9nhs');
        args.el = args.els[0];
        ((a) => { window.BeaeSlideshow&&window.BeaeSlideshow.init(a) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-pvvb9nhs: ', ex)
      };
    

      try {
        let argid = 'beae-pvvb9nhssection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-pvvb9nhs',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-pvvb9nhs');
        args.el = args.els[0];
        ((u) => { window.BeaeSlider&&!u.noRunJs&&window.BeaeSlider(u) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-pvvb9nhs: ', ex)
      };
    

      try {
        let argid = 'beae-0cgt84r9block-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0cgt84r9',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0cgt84r9');
        args.el = args.els[0];
        ((U) => { if(U.el){let Y,oe=U.autoHover;var X=U.el.querySelector(".beae-img-ratio-control"),O=U.el.querySelector(".beae-img-comp-container"),G=U.el.querySelector(".beae-img-comp-container--second");if(X&&G){let ae=function(ie){let se=0,te,de,j;D(),oe?U.el.onmouseover=function(pe){R(pe)}:ie.onmousedown=function(pe){R(pe)},U.el.onmouseup=function(){J()},ie.ontouchstart=function(pe){R(pe)},U.el.ontouchend=function(){J()};function D(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Y=G.offsetWidth})}).observe(G),ie.style.left&&(de=parseInt(ie.style.left))}function R(pe){check=!1,pe.preventDefault(),pe.clientX?te=pe.clientX:te=pe.touches[0].clientX,se=1,U.el.onmousemove=function(he){W(he)},U.el.ontouchmove=function(he){W(he)}}function J(){se=0,isNaN(j)||(de=j),check=!0}function W(pe){if(se==0||oe&&!(pe.target==G||pe.target==U.el.querySelector(".beae-image-secondary")))return!1;j=ce(pe),j<0&&(j=0),j>100&&(j=100),me(j)}function ce(pe){pe=pe.changedTouches?pe.changedTouches[0]:pe;let he;return oe?he=Math.round(pe.offsetX*100/Y):he=Math.round(de-(te-pe.pageX)*100/Y),he}function me(pe){ie.style.left=pe+"%",G.style.clipPath=`polygon(${pe}% 0%, ${pe}% 100%, 100% 100%, 100% 0)`,O.style.clipPath=`polygon(0% 100%, 0% 0%, ${pe}% 0%, ${pe}% 100%)`}};X&&G&&ae(X),window.addEventListener("resize",function(){X&&G&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Y=G.offsetWidth})}).observe(G),ae(X))})}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0cgt84r9: ', ex)
      };
    }; if (window.BEAEBASE) {js_9BGI7B8M()} else {window.BEAEPAGEJS.push(js_9BGI7B8M)} })(); 